import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// The "stack of events" icon shown for a series wherever it needs a visual identity in place of a
// real image — the series list (SeriesCard) and a series' hidden parent event's detail-page
// thumbnail (detail/components/dashboard-hero.tsx).
export function SeriesStackIcon() {
	return (
		<div className="relative w-[52px] h-[46px] flex-none">
			<div className="absolute left-[6px] top-0 w-10 h-10 rounded-lg bg-white/10 border border-white-20" />
			<div className="absolute left-[3px] top-[3px] w-10 h-10 rounded-lg bg-primary/60" />
			<div className="absolute left-0 top-[6px] w-10 h-10 rounded-lg bg-primary flex items-center justify-center text-white">
				<FontAwesomeIcon icon={['fas', 'folder']} />
			</div>
		</div>
	)
}
